
define(
	'BluePoint.VerifyEmail.VerifyEmail'
,   [
		'BluePoint.VerifyEmail.VerifyEmail.View'
	]
,   function (
		VerifyEmailView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{			
			var VerifyRegisterPage = container.getComponent('LoginRegisterPage');
			var environment = container.getComponent("Environment");
			var isactive = environment.getConfig('verifyemail.isactive');
			var enabled = environment.getConfig('emailVerification.enabled');

			console.log('enabled =========> ', enabled);

			if (isactive && VerifyRegisterPage) {
				return new VerifyEmailView ({
					VerifyRegisterPage: VerifyRegisterPage,
					application: container,
					environment: environment
				});
			}
		}
	};
});
